<template>
  <div class="mod">
    <div class="box">
      <img
        class="largeIcon"
        src="/static/img/对勾.svg"
        data-src="/static/img/对勾.svg"
        alt="largeIcon"
      />
      <span class="info">
      合同签署成功
    </span>
      <div class="submain" @click="gotoOrderList">
      <span>
        查看订单
      </span>
      </div>
      <div class="submain-c" @click="revert">
      <span>
        返回主页
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import Emkt from './../../emkt'
import wx from 'wx'

export default {
  name: 'PromotionSuccess',
  methods: {
    gotoOrderList () {
      this.$router.replace({name: 'WeappMyOrders'})
    },
    revert () {
      if (Emkt.isWapp) {
        wx.miniProgram.switchTab({
          url: '/pages/index/index'
        })
      } else {
        this.$router.replace({name: 'home'})
      }
    }
  }
}
</script>

<style scoped>

.mod {
  height: 100vh;
}
.box {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fafafa;
  height: 812px;
  overflow: hidden;
}

.largeIcon {
  position: relative;
  margin-top: 105px;
  width: 61px;
  height: 61px;
}

.info {
  position: relative;
  margin-top: 19px;
  max-width: 287px;
  height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 28px;
  white-space: nowrap;
  color: #424242;
  font-size: 20px;
  font-weight: 400;
}

.summary {
  margin-top: 10px;
  width: 100%;
  color: #929292;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
}

.submain {
  text-align: center;
  padding: 10px;
  /*flex-direction: row;*/
  justify-content: center;
  margin-top: 20px;
  border-radius: 22px;
  background-color: #5878fa;
  border: 1px solid #5878fa;
  width: 70%;
  color: white;
  font-size: 15px;
}
.submain-c {
  text-align: center;
  padding: 10px;
  /*flex-direction: row;*/
  justify-content: center;
  margin-top: 20px;
  border-radius: 22px;
  background-color: white;
  width: 70%;
  color: #5878fa;
  font-size: 15px;
  border: 1px solid #5878fa;
}
</style>




// WEBPACK FOOTER //
// PromotionSuccess.vue?4d746362